import React, { useState } from "react";
import JobDetailsModal from "./JobDetailsModal";
import VersionHistoryViewer from "./VersionHistoryViewer";
import WorkflowLauncher from "./WorkflowLauncher";
import EstimateWorkbench from "./workbench/estimate/EstimateWorkbench";
import { useAuth } from "../context/AuthContext";
import "./DashboardPage.css";

/**
 * The estimate route.
 *
 * The screen itself is the Workbench: the job's line items on the left, the
 * selected line's editor in the middle, and the cost trace on the right. This
 * component is the route host — it owns the modals (save, versions, guided
 * intake) and hands everything else to <EstimateWorkbench>.
 *
 * Saved jobs are a destination (`/jobs`), not a modal over the estimate: the
 * JobList overlay this used to render had no door left into it.
 */
function DashboardPage({
  state,
  dispatch,
  currentJob,
  viewingVersionNumber,
  onJobSaved,
  onNewJobClick,
  showVersionHistory,
  setShowVersionHistory,
  onVersionSelect,
  onLoadLatest,
  onCalculate,
  isCalculating,
  calculationError,
  results,
  resultsStale,
  showWorkflowLauncher,
  setShowWorkflowLauncher,
  workflowLauncherError,
  isCreatingEstimate,
  onCreateEstimate,
  onWorkflowNavigate,
  isAdmin: isAdminOverride,
}) {
  const { isAdmin: authIsAdmin } = useAuth();
  const isAdmin = isAdminOverride ?? authIsAdmin;
  const [jobDetailsModal, setJobDetailsModal] = useState(null); // null | 'save' | 'edit'

  return (
    <>
      <EstimateWorkbench
        formData={state}
        dispatch={dispatch}
        currentJob={currentJob}
        viewingVersionNumber={viewingVersionNumber}
        results={results}
        resultsStale={resultsStale}
        isCalculating={isCalculating}
        calculationError={calculationError}
        onCalculate={onCalculate}
        onSaveClick={() => setJobDetailsModal("save")}
        onNewJobClick={onNewJobClick}
        onShowVersionHistory={() => setShowVersionHistory(true)}
        onLoadLatest={onLoadLatest}
        isAdmin={isAdmin}
      />

      {showVersionHistory && currentJob && (
        <div className="modal-overlay">
          <VersionHistoryViewer
            jobId={currentJob.id}
            onVersionSelect={onVersionSelect}
            onClose={() => setShowVersionHistory(false)}
          />
        </div>
      )}

      <JobDetailsModal
        mode={jobDetailsModal}
        formData={state}
        dispatch={dispatch}
        currentJob={currentJob}
        viewingVersionNumber={viewingVersionNumber}
        onJobSaved={onJobSaved}
        onClose={() => setJobDetailsModal(null)}
      />
      <WorkflowLauncher
        open={showWorkflowLauncher}
        isAdmin={isAdmin}
        isSaving={isCreatingEstimate}
        error={workflowLauncherError}
        defaultTier={state.default_client_pricing_tier}
        onClose={() => setShowWorkflowLauncher(false)}
        onCreateEstimate={onCreateEstimate}
        onNavigate={onWorkflowNavigate}
      />
    </>
  );
}

export default DashboardPage;
